import cx from 'classnames'

export function TableRow({
  id,
  children,
  className
}: {
  id?: string
  children: React.ReactNode
  className?: string
}) {
  return (
    <tr id={id} className={cx('table-row group/rows', className)}>
      {children}
    </tr>
  )
}
